import React from "react";
import { Link } from "react-router-dom";

const WhyChooseUs = () => {
  return (
    <React.Fragment>
      <section className="section bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-4 pb-2">
                <h6 className="text-primary fw-bold mb-3">
                  WHY CHOOSE FORMAX PAY
                </h6>
                <h4 className="title mb-4">
                  Enterprise-Grade API Infrastructure
                </h4>
                <p className="text-muted para-desc mx-auto mb-0">
                  Built for scale, security, and compliance. Power your
                  financial products with our battle-tested API platform.
                </p>
              </div>
            </div>
            {/*end col*/}
          </div>
          {/*end row*/}

          <div className="row" style={{ paddingBottom: "100px" }}>
            {/* Bank-Grade Security - FIXED WITH PROPER ICON */}
            <div className="col-md-4 col-12">
              <div className="features feature-primary text-center p-4 rounded shadow-sm border border-light h-100">
                <div className="position-relative d-inline-block mb-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto why-choose-icon">
                    <i className="fas fa-shield-alt fa-2x text-primary"></i>
                  </div>
                </div>
                <div className="content">
                  <h5 className="mb-3">Bank-Grade Security</h5>
                  <p className="text-muted mb-0">
                    Enterprise-grade infrastructure featuring end-to-end
                    encryption, risk controls, and continuous security
                    monitoring.
                  </p>
                </div>
              </div>
            </div>
            {/*end col*/}

            {/* High Performance - FIXED WITH PROPER ICON */}
            <div className="col-md-4 col-12 mt-4 mt-md-0">
              <div className="features feature-primary text-center p-4 rounded shadow-sm border border-light h-100">
                <div className="position-relative d-inline-block mb-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto why-choose-icon">
                    <i className="fas fa-bolt fa-2x text-primary"></i>
                  </div>
                </div>
                <div className="content">
                  <h5 className="mb-3">High Performance</h5>
                  <p className="text-muted mb-0">
                    99.9% uptime SLA with 200ms response times. Built to handle
                    millions of transactions with zero latency.
                  </p>
                </div>
              </div>
            </div>
            {/*end col*/}

            {/* Full Compliance - FIXED WITH PROPER ICON */}
            <div className="col-md-4 col-12 mt-4 mt-md-0">
              <div className="features feature-primary text-center p-4 rounded shadow-sm border border-light h-100">
                <div className="position-relative d-inline-block mb-4">
                  <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto why-choose-icon">
                    <i className="fas fa-file-contract fa-2x text-primary"></i>
                  </div>
                </div>
                <div className="content">
                  <h5 className="mb-3">Full Compliance</h5>
                  <p className="text-muted mb-0">
                    Strong controls, periodic audits, and continuous monitoring
                    aligned with regulatory expectations.
                  </p>
                </div>
              </div>
            </div>
            {/*end col*/}
          </div>
          {/*end row*/}

          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <a href="https://developers.formaxpay.com" target="_blank">
                <img
                  src="/images/curl_banner_4.png"
                  className="img-fluid rounded shadow-lg"
                  alt="API Integration Dashboard"
                />
              </a>
            </div>
            {/*end col*/}
            <div className="col-lg-6 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div className="section-title ms-lg-5">
                <h4 className="title mb-4">
                  Seamless Integration with Comprehensive Documentation
                </h4>
                <p className="text-muted">
                  Our developer-friendly APIs come with extensive documentation,
                  SDKs in multiple languages, and 24/7 technical support. Get
                  production-ready in days, not months.
                </p>
                <ul className="list-unstyled text-muted">
                  <li className="mb-2">
                    <span className="text-primary h5 me-2">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    RESTful APIs with JSON responses
                  </li>
                  <li className="mb-2">
                    <span className="text-primary h5 me-2">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    SDKs for Node.js, Python, Java, PHP
                  </li>
                  <li className="mb-2">
                    <span className="text-primary h5 me-2">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    Postman collections & API playground
                  </li>
                  <li className="mb-2">
                    <span className="text-primary h5 me-2">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    Webhook support for real-time notifications
                  </li>
                </ul>
                <a
                  href="https://developers.formaxpay.com"
                  target="_blank"
                  className="mt-3 h5 text-primary text-decoration-none"
                >
                  Explore Documentation{" "}
                  <i className="fas fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
            {/*end col*/}
          </div>
          {/*end row*/}

          <div className="row align-items-center mt-100">
            <div className="col-lg-6 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div className="section-title me-lg-5">
                <h4 className="title mb-4">
                  Real-Time Monitoring & Analytics Dashboard
                </h4>
                <p className="text-muted">
                  Monitor your API usage, track transactions in real-time, and
                  get actionable insights with our comprehensive dashboard. Set
                  up alerts, generate reports, and optimize performance.
                </p>
                <ul className="list-unstyled text-muted">
                  <li className="mb-2">
                    <span className="text-primary h5 me-2">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    Live transaction monitoring
                  </li>
                  <li className="mb-2">
                    <span className="text-primary h5 me-2">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    Customizable analytics reports
                  </li>
                  <li className="mb-2">
                    <span className="text-primary h5 me-2">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    Webhook logs & error tracking
                  </li>
                  <li className="mb-2">
                    <span className="text-primary h5 me-2">
                      <i className="fas fa-check-circle"></i>
                    </span>
                    SLA compliance monitoring
                  </li>
                </ul>
                <a
                  href="https://app.formaxpay.com/partner-login"
                  target="_blank"
                  className="mt-3 h5 text-primary text-decoration-none"
                >
                  View Dashboard Demo{" "}
                  <i className="fas fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
            {/*end col*/}
            <div className="col-lg-6 col-md-6 order-1 order-md-2">
              <img
                src="/images/recharge_report.jpg"
                className="img-fluid rounded shadow-lg w-100"
                alt="Analytics Dashboard"
                style={{ height: "350px", objectFit: "cover" }}
              />
            </div>
            {/*end col*/}
          </div>
        </div>
      </section>

      {/* Add CSS to fix the icon styling */}
      <style jsx>{`
        .why-choose-icon {
          width: 80px;
          height: 80px;
          background-color: rgba(
            13,
            110,
            253,
            0.1
          ) !important; /* Light primary background */
          border: none !important;
        }

        .why-choose-icon i {
          color: #0d6efd !important; /* Primary color for icons */
        }

        /* Hover effect for better UX */
        .features:hover .why-choose-icon {
          background-color: rgba(13, 110, 253, 0.15) !important;
          transform: scale(1.05);
          transition: all 0.3s ease;
        }

        .features:hover .why-choose-icon i {
          color: #0b5ed7 !important; /* Darker primary on hover */
        }
      `}</style>
    </React.Fragment>
  );
};

export default WhyChooseUs;
